import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const chapters = [{
  num: 1,
  title: 'Base física del jugador de handball: construir el cuerpo antes de exigirlo'
}, {
  num: 2,
  title: 'Fuerza funcional para handball: ganar contacto, estabilidad y potencia real'
}, {
  num: 3,
  title: 'Velocidad, agilidad y cambios de dirección: llegar antes, frenar mejor y ganar duelos'
}, {
  num: 4,
  title: 'Potencia, salto y lanzamiento: explosividad para definir, lanzar y superar rivales'
}, {
  num: 5,
  title: 'Resistencia específica: rendir todo el partido sin apagarte en los minutos finales'
}, {
  num: 6,
  title: 'Sistema de rendimiento completo: planificación, progresión y prevención de lesiones'
}];
export function Chapters() {
  return <section className="py-12 px-4 bg-brand-base" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <h2 className="text-3xl md:text-4xl font-oswald font-bold text-center mb-10 text-white uppercase tracking-wide" data-id="element-72">
          6 Capítulos que <span className="text-accent-base" data-id="element-73">transforman</span>{' '}
          tu juego
        </h2>

        <div className="flex flex-col gap-4" data-id="element-74">
          {chapters.map(ch => <div key={ch.num} className="bg-brand-light border border-white/10 rounded-xl p-5 flex items-start gap-4 shadow-lg" data-id="element-75">
              <div className="flex-shrink-0 bg-accent-base text-white font-oswald font-bold text-xl w-12 h-12 rounded-lg flex items-center justify-center shadow-inner" data-id="element-76">
                {ch.num}
              </div>
              <div className="flex flex-col justify-center min-h-[3rem]" data-id="element-77">
                <span className="text-accent-base text-xs font-bold tracking-wider uppercase mb-1" data-id="element-78">
                  Capítulo {ch.num}
                </span>
                <h3 className="text-white font-medium text-base md:text-lg leading-snug" data-id="element-79">
                  {ch.title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}